<template>
    <div id="achievement">
       <div class="title">
            <p>成绩信息：{{is_open.fraction}}</p>
           <p>录取信息：{{is_open.enter}}</p>
       </div>
     
    </div>
</template>

<script>
import { getSchool } from '@/utils/auth.js';
import { getfraction } from '@/api/login/login.js';
export default {
    name: "achievement",
    data() {
        return {
             title:'',
             is_open:'',
        };
    },
    created(){
        this.title = JSON.parse(getSchool()).project_name;
        // 获取按钮
        this.getbtn()
    },
    methods: {
          /**
             * 成绩信息
             * @method getbtn
             */
            getbtn(){
            // let obj = JSON.parse(getInfo());
            let formData = new FormData();
            formData.append('request', JSON.stringify({'project_id': JSON.parse(getSchool()).project_id}));
            getfraction(formData).then( res => {
                if (res.code == 0) {
            
                this.is_open = res.data;
                }else {
                this.$toast(res.msg);
                }
            }).catch(error=>{
                this.$toast('请联系管理员');
            })
            },
    },
   
};
</script>

<style lang="scss">
#achievement {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    background-color: #f6f6f6;
    .title {
        width: 85%;
        margin: 0 auto;
        // color: #2372AD;
        font-size: 0.42rem;
        padding-top: 0.7rem;
        p{
            font-size: 0.35rem;
            line-height: 0.5rem;
             padding-top: 0.3rem;
        }
    }
   
   
}
</style>

